// extracted by mini-css-extract-plugin
export default {"word":"Word_word__tisCT","absolute":"Word_absolute__4ciEJ","wordTitle":"Word_wordTitle__pkqXi","long-word":"Word_long-word__nrhus","transcription":"Word_transcription__Z8Y7d"};